import { Tooltip } from "@mui/material";
import css from "../../css/modules/toolbar.module.scss";
import { ToggleButton } from '@mui/material';
import { translate } from "../../utils/translate";
import { useCallback, useEffect, useState } from "react";

export function ToggleVisibilityButtons({
  overview,
  api,
  configs,
  hideGantt,
  hideScheduler,
  hideHistogram,
  hideUtilization = true,
}) {
  const [state, setState] = useState(() => {
    const { showGantt, showScheduler, showHistogram, showUtilization } = overview?.visiblePartsConfig || configs;
    return {
      gantt: showGantt,
      scheduler: showScheduler,
      histogram: showHistogram,
      utilization: showUtilization,
    };
  });
  useEffect(() => {
    if (overview) {
      //save used config (used on department screen)
      overview.visiblePartsConfig = {
        showGantt: state.gantt,
        showScheduler: state.scheduler,
        showHistogram: state.histogram,
        showUtilization: state.utilization,
      };
    }
    return () => {
      if (overview) {
        //save used config (used on department screen)
        overview.visiblePartsConfig = {
          showGantt: state.gantt,
          showScheduler: state.scheduler,
          showHistogram: state.histogram,
          showUtilization: state.utilization,
        };
      }
    };
  }, [state, overview]);
  const handleFormat = useCallback(
    async (event, name) => {
      const value = !state[name];
      const newState = {
        ...state,
        [name]: value,
      };
      setState({
        ...newState,
        utilization: name === "histogram" && value ? false : newState.utilization,
        histogram: name === "utilization" && value ? false : newState.histogram,
      });
      switch (name) {
        case "gantt": {
          if (!value) {
            await overview.toggleGanttVisible(false);
            api.gantt?.hide();
          } else {
            await overview.toggleGanttVisible(true);
            api.gantt?.show();
          }
          if (overview.showParts) {
            overview.showParts.gantt = value;
          }
          break;
        }
        case "scheduler": {
          if (!value) {
            await overview.toggleSchedulerVisible(false);
            api.scheduler?.hide();
          } else {
            await overview.toggleSchedulerVisible(true);
            api.scheduler?.show();
          }
          if (overview.showParts) {
            overview.showParts.showScheduler = value;
          }
          break;
        }
        case "histogram": {
          if (value) {
            if (!hideUtilization) {
              await overview?.toggleUtilizationVisible(false);
              api.utilization?.hide();
            }
            await overview?.toggleHistogramVisible(true);
            api.histogram?.show();
          } else {
            await overview?.toggleHistogramVisible(false);
            api.histogram?.hide();
          }
          if (overview.showParts) {
            overview.showParts.showHistogram = value;
            overview.showParts.showUtilization = !value;
          }
          break;
        }
        case "utilization": {
          if (value) {
            await overview.toggleHistogramVisible(false);
            api.histogram?.hide();
            await overview?.toggleUtilizationVisible(true);
            api.utilization?.show();
          } else {
            await overview?.toggleUtilizationVisible(false);
            api.utilization?.hide();
          }
          if (overview.showParts) {
            overview.showParts.showUtilization = value;
            overview.showParts.showHistogram = !value;
          }
          break;
        }
        default:
          break;
      }
    },
    [state, api, overview, hideUtilization]
  );

  return (
    <div className={css.btnContainer}>
      {!hideGantt && (
        <Tooltip title={translate("Toggle gantt visibility")}>
          <ToggleButton
            selected={state.gantt}
            onChange={handleFormat}
            value="gantt"
            size="small"
            className={css.iconBtn}
            data-testid="tb_depview_toggle_gantt"
          >
            <span className="b-fa b-fa-chart-gantt" />
          </ToggleButton>
        </Tooltip>
      )}
      {!hideScheduler && (
        <Tooltip title={translate("Toggle resources visibility")}>
          <ToggleButton
            selected={state.scheduler}
            onChange={handleFormat}
            value="scheduler"
            size="small"
            className={css.iconBtn}
            data-testid="tb_depview_toggle_resources"
          >
            <span className="b-fa b-fa-users" />
          </ToggleButton>
        </Tooltip>
      )}
      {!hideHistogram && (
        <Tooltip title={translate("Toggle histogram visibility")}>
          <ToggleButton
            selected={state.histogram}
            onChange={handleFormat}
            value="histogram"
            size="small"
            className={css.iconBtn}
            data-testid="tb_depview_toggle_histogram"
          >
            <span className="b-fa b-fa-chart-line" />
          </ToggleButton>
        </Tooltip>
      )}
      {!hideUtilization && (
        <Tooltip title={translate("Toggle utilization visibility")}>
          <ToggleButton
            selected={state.utilization}
            onChange={handleFormat}
            value="utilization"
            size="small"
            className={css.iconBtn}
            data-testid="tb_depview_toggle_utilization"
          >
            <span className="b-fa b-fa-table-cells-large" />
          </ToggleButton>
        </Tooltip>
      )}
    </div>
  );
}
